import { MdOutlineClose, MdOutlineCheck } from "react-icons/md";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import { HiOutlineX } from "react-icons/hi";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../redux/actions/loadingActions/loadingActions";
import {
  getLiveTransactionAdminService,
  changeOrderTypeAdminServices,
} from "../../services/userServices";

import PersianNumber from "./../../utils/PersianNumber/PersianNumber";

const AdminOrderButton = ({ setHesabiApiStatus }) => {
  const dispatch = useDispatch();

  const [latestItem, setLatestItem] = useState(null);
  const [getOrders, setGetOrders] = useState([]);

  //* Handle Get Live Orders
  const handleGetLiveOrders = async () => {
    try {
      const { status, data } = await getLiveTransactionAdminService();
      if (status === 200) {
        setGetOrders(data);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    }
  };

  //* Change Order Type Live Orders
  const handleChangeOrderType = async (id, tType) => {
    const objData = { id, tType };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changeOrderTypeAdminServices(objData).then(
        (response) => {
          setHesabiApiStatus(response?.data?.hesabi_api_sent);
        }
      );
      if (status === 200) {
        handleGetLiveOrders();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  useEffect(() => {
    handleGetLiveOrders();
  }, []);

  useEffect(() => {
    if (getOrders?.length) {
      setLatestItem(getOrders[getOrders.length - 1]);
    }
  }, [getOrders]);

  return (
    <>
      <span className="w-full flex flex-col">
        {/* Text */}
        <span className="text-center w-full h-full flex flex-col justify-center gap-y-2 py-2 px-5">
          <span>
            سفارش{" "}
            <span
              className={`${
                latestItem?.bos === "B" ? "text-[#00FF00]" : "text-[#FF073A]"
              }`}
            >
              {latestItem?.bos === "B" ? "خرید" : "فروش"}
            </span>{" "}
            جدید ثبت شد - شماره سفارش: {latestItem?.transaction_id}
          </span>
          {latestItem && (
            <span className="grid grid-cols-2 w-full pb-2 tracking-wide">
              {/* Right Column */}
              <ul className="flex flex-col text-right w-full space-y-5">
                {/* User Name */}
                <li>
                  <span>کاربر</span>
                </li>
                {/* Product Name */}
                <li>
                  <span>محصول</span>
                </li>
                {/* Weight */}
                <li>
                  <span className="flex">
                    حجم
                    <p className="text-xs px-1 flex items-center text-[#007BFF]">
                      ( {latestItem?.tag === "S" ? "تعداد" : "مقدار (گرم)"} )
                    </p>
                  </span>
                </li>
                {/* Price */}
                <li>
                  <span className="flex">
                    قیمت
                    <p className="text-xs px-1 flex items-center text-[#007BFF]">
                      ( تومان )
                    </p>
                  </span>
                </li>
                {/* Total */}
                <li>
                  <span className="flex">
                    مبلغ
                    <p className="text-xs px-1 flex items-center text-[#007BFF]">
                      ( تومان )
                    </p>
                  </span>
                </li>
                {/* Ordery Status */}
                <li>
                  <span>اردری</span>
                </li>
              </ul>
              {/* Left Column */}
              <ul className="flex flex-col text-left w-full space-y-5">
                {/* User Name */}
                <li>
                  <span>{latestItem.customeruser}</span>
                </li>
                {/* Product Name */}
                <li>
                  <span>{latestItem?.product_name}</span>
                </li>
                {/* Weight */}
                <li>
                  <span>
                    <PersianNumber
                      value={latestItem?.volume}
                      thousandSeparator=","
                    />
                  </span>
                </li>
                {/* Price */}
                <li>
                  <span className="flex justify-end">
                    <PersianNumber
                      value={latestItem?.price}
                      thousandSeparator=","
                    />
                  </span>
                </li>
                {/* Total */}
                <li>
                  <span className="flex justify-end">
                    <PersianNumber
                      value={latestItem?.amount}
                      thousandSeparator=","
                    />
                  </span>
                </li>
                {/* Ordery Status */}
                <li>
                  <span className="flex justify-end">
                    {latestItem?.is_orderi ? (
                      <MdOutlineCheck size={26} fill="#00FF00" />
                    ) : (
                      <HiOutlineX size={26} className="text-[#FF073A]" />
                    )}
                  </span>
                </li>
              </ul>
            </span>
          )}
          <span>
            <a
              href="/Public/Live-Transactions"
              className="text-[#007BFF]"
              onClick={(e) => e.stopPropagation()}
            >
              مشاهده سفارش
            </a>
          </span>
        </span>
        {/* Button */}
        <span
          className="w-full flex justify-center items-center
          py-1 mt-2 font-medium text-sm tracking-wide text-gray-100"
        >
          <button
            onClick={() => handleChangeOrderType(latestItem?.id, "T")}
            className="bg-green-600 border-2 border-green-600
          mx-5 rounded-xl px-4 py-0.5 transition-all ease-linear focus:ring-0
          duration-100 hover:transition-all hover:ease-linear hover:duration-100"
          >
            <MdOutlineCheck size={25} />
          </button>
          <button
            onClick={() => handleChangeOrderType(latestItem?.id, "L")}
            className="bg-red-600 border-2 border-red-600
          mx-5 rounded-xl px-4 py-0.5 transition-all ease-linear focus:ring-0
          duration-100 hover:transition-all hover:ease-linear hover:duration-100"
          >
            <MdOutlineClose size={25} />
          </button>
        </span>
      </span>
    </>
  );
};

export default AdminOrderButton;
